import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  infestLevelId: '',
  infestLevelData: [],
  infestName: '',
  infestCrop: '',
  mode: 'view',
};

export const infestSlice = createSlice({
  name: 'infestation',
  initialState,
  reducers: {
    setInfestLevelId(state, actions) {
      state.infestLevelId = actions.payload;
    },
    setInfestLevelData(state, actions) {
      state.infestLevelData = actions.payload;
    },
    setInfestName(state, actions) {
      state.infestName = actions.payload;
    },
    setInfestCrop(state, actions) {
      state.infestCrop = actions.payload;
    },
    setInfestMode(state, actions) {
      state.mode = actions.payload;
    },
  },
});

export const {
  setInfestLevelId,
  setInfestLevelData,
  setInfestName,
  setInfestCrop,
  setInfestMode,
} = infestSlice.actions;

export default infestSlice.reducer;
